const usage = [
  {
    midText: '71%+',
    lowerText: '',
  },
  {
    midText: '51-70%',
    lowerText: '',
  },
  {
    midText: '31-50%',
    lowerText: '',
  },
  {
    midText: '11-30%',
    lowerText: '',
  },
  {
    midText: '0-10%',
    lowerText: '',
  },
];

const paymentHistory = [
  {
    midText: '',
    lowerText: '',
  },
  {
    midText: '',
    lowerText: '',
  },
  {
    midText: '',
    lowerText: 'derogatory',
  },
  {
    midText: '',
    lowerText: 'delinquent',
  },
  {
    midText: '',
    lowerText: '',
  },
];

const age = [
  {
    midText: '< 1 yr',
    lowerText: '',
  },
  {
    midText: '1-2 yrs',
    lowerText: '',
  },
  {
    midText: '2-3 yrs',
    lowerText: '',
  },
  {
    midText: '3-5 yrs',
    lowerText: '',
  },
  {
    midText: '5+ yrs',
    lowerText: '',
  },
];

const mix = [
  {
    midText: '',
    lowerText: '',
  },
  {
    midText: '',
    lowerText: '',
  },
  {
    midText: '',
    lowerText: '',
  },
  {
    midText: '',
    lowerText: '',
  },
  {
    midText: '',
    lowerText: '',
  },
];

const inquiries = [
  {
    midText: '9+',
    lowerText: '',
  },
  {
    midText: '6-8',
    lowerText: '',
  },
  {
    midText: '3-5',
    lowerText: '',
  },
  {
    midText: '1-2',
    lowerText: '',
  },
  {
    midText: '0',
    lowerText: '',
  },
];

const config = [
  {
    lineColor: 'borderRed3',
    lineBackground: 'bgRed3',
    youBgColor: 'bgRed0',
    youFontColor: 'fontRed6',
    goalBgColor: 'bgRed3',
    goalFontColor: 'fontGray8',
    topText: 'F',
  },
  {
    lineColor: 'borderOrange3',
    lineBackground: 'bgOrange3',
    youBgColor: 'bgOrange0',
    youFontColor: 'fontOrange6',
    goalBgColor: 'bgOrange3',
    goalFontColor: 'fontGray8',
    topText: 'D',
  },
  {
    lineColor: 'borderYellow3',
    lineBackground: 'bgYellow3',
    youBgColor: 'bgYellow0',
    youFontColor: 'fontYellow6',
    goalBgColor: 'bgYellow3',
    goalFontColor: 'fontGray8',
    topText: 'C',
  },
  {
    lineColor: 'borderLgreen3',
    lineBackground: 'bgLgreen3',
    youBgColor: 'bgLgreen0',
    youFontColor: 'fontLgreen7',
    goalBgColor: 'bgLgreen3',
    goalFontColor: 'fontGray8',
    topText: 'B',
  },
  {
    lineColor: 'borderGreen3',
    lineBackground: 'bgGreen3',
    youBgColor: 'bgGreen0',
    youFontColor: 'fontGreen6',
    goalBgColor: 'bgGreen3',
    goalFontColor: 'fontGray8',
    topText: 'A',
  },
];

export { config, age, inquiries, usage, mix, paymentHistory };
